import React from "react";
import { Table, Button, Popover, OverlayTrigger } from "react-bootstrap";
import { apiUrl } from "../../config";
import { Edit, Eye, Trash } from "lucide-react";

const CategoryList = ({ category, onEdit, onDelete, onView }) => {
  const viewPopover = (
    <Popover id="popover-view">
      <Popover.Body>View Category details</Popover.Body>
    </Popover>
  );
  const editPopover = (
    <Popover id="popover-view">
      <Popover.Body>Edit Category details</Popover.Body>
    </Popover>
  );
  const deletePopover = (
    <Popover id="popover-view">
      <Popover.Body>Delete Category </Popover.Body>
    </Popover>
  );
  return (
    <Table className="custom-employee-table" bordered hover responsive>
      <thead>
        <tr>
          <th>S.No</th>
          <th>Name</th>
          <th>Image</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {category.length > 0 ? (
          category.map((cat, idx) => (
            <tr key={cat.id}>
              <td>{idx + 1}</td>
              <td>{cat.name}</td>

              <td>
                <img
                  src={apiUrl + "/" + cat.imageUrl}
                  // alt={ad.name}
                  className="student-thumbnail"
                  style={{
                    objectFit: "contain",
                    height: "70px",
                    width: "70px",
                  }}
                />
              </td>
              <td>
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={viewPopover}
                >
                  <Button
                    size="sm"
                    className="me-1"
                    style={{
                      backgroundColor: "#10296C",
                      padding: "5px",
                      borderRadius: "5px",
                      marginRight: "5px",
                    }}
                    onClick={() => onView(cat)}
                  >
                    <Eye />
                  </Button>
                </OverlayTrigger>
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={editPopover}
                >
                  <Button
                    size="sm"
                    variant="warning"
                    style={{
                      padding: "5px",
                      borderRadius: "5px",
                      marginRight: "5px",
                    }}
                    className="me-1"
                    onClick={() => onEdit(cat)}
                  >
                    <Edit />
                  </Button>
                </OverlayTrigger>
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={deletePopover}
                >
                  <Button
                    size="sm"
                    variant="danger"
                    style={{
                     
                      padding: "5px",
                      borderRadius: "5px",
                      marginRight: "5px",
                    }}
                    onClick={() => onDelete(cat.id)}
                  >
                    <Trash />
                  </Button>
                </OverlayTrigger>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="6" className="text-center">
              No Category found.
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default CategoryList;
